/* eslint-disable no-inline-styles/no-inline-styles */
import type {
    ActivityTileV1Attributes,
    ActivityTilesV1Attributes,
} from '@/features/activity-tiles/activity-tiles-v1/activity-tiles-v1-type';

import chunk from 'lodash.chunk';

import { bemModule } from '@/core/utils/bem-classname';
import ActivityTile from '@/features/activity-tiles/activity-tiles-v1/activity-tile-v1';

import styles from './activity-tiles-v1.module.scss';

const bem = bemModule(styles);

export type ActivityTilesV1Props = ActivityTilesV1Attributes;

export default function ActivityTilesV1({ tiles }: ActivityTilesV1Props) {
    if (tiles.length <= 3) {
        return (
            <div className={bem(styles.tilesGrid, { [`layout${tiles.length}`]: true })}>
                {tiles.map((activityTile, index) => {
                    return (
                        <div
                            key={activityTile.title}
                            style={{ gridArea: `tile${index + 1}` }}
                        >
                            <ActivityTile
                                {...activityTile}
                                height={getHeight(tiles.length, index)}
                                width={'100%'}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }

    return (
        <div
            className={`no-scrollbar full-width padding-16 -margin-top-16 -margin-bottom-16 gap-8 ${styles.tilesSwiper}`}
        >
            {getFormatedTiles(tiles).map((activityTile) => {
                if (!Array.isArray(activityTile)) {
                    return (
                        <ActivityTile
                            {...activityTile}
                            height={308}
                            key={activityTile.title}
                            width={150}
                        />
                    );
                }

                const topTile = activityTile[0];
                const bottomTile = activityTile[1];

                return topTile && bottomTile ? (
                    <div
                        className={'flex-column gap-8'}
                        key={topTile.title}
                    >
                        <ActivityTile
                            {...topTile}
                            height={150}
                            width={150}
                        />
                        <ActivityTile
                            {...bottomTile}
                            height={150}
                            width={150}
                        />
                    </div>
                ) : null;
            })}
        </div>
    );
}

const getHeight = (size: number, index: number) => {
    if (size === 1) {
        return 180;
    }
    if (size === 2) {
        return 150;
    }
    return index === 0 ? 308 : 150;
};

const getFormatedTiles = (tiles: ActivityTileV1Attributes[]) => {
    const isEvenNumOfTiles = tiles.length % 2 === 0;
    const firstTile = tiles[0];
    const lastTile = isEvenNumOfTiles ? tiles[tiles.length - 1] : null;
    const restOfTiles = tiles.slice(1, tiles.length - (isEvenNumOfTiles ? 1 : 0));
    return firstTile ? [firstTile, ...chunk(restOfTiles, 2), ...(lastTile ? [lastTile] : [])] : [];
};
